var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18586_561742)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9953 0C7.60906 0 0 7.38732 0 16.4999C0 25.6127 7.60906 33 16.9953 33C26.3815 33 33.9905 25.6127 33.9905 16.4999C33.9905 7.38732 26.3815 0 16.9953 0ZM16.9953 30.2732C9.16028 30.2732 2.80872 24.1067 2.80872 16.5C2.80872 8.89334 9.16028 2.72687 16.9953 2.72687C24.8303 2.72687 31.1818 8.89334 31.1818 16.5C31.1818 24.1067 24.8303 30.2732 16.9953 30.2732Z",
    fill: "url(#paint0_linear_18586_561742)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4748 30.9902C25.3098 30.9902 31.6614 24.8238 31.6614 17.2171C31.6614 14.2402 30.6885 11.4841 29.0348 9.23169C30.3963 11.3461 31.1841 13.8445 31.1841 16.5219C31.1841 24.1286 24.8325 30.295 16.9975 30.295C12.2286 30.295 8.00956 28.0105 5.4375 24.5073C7.94404 28.4001 12.3975 30.9902 17.4748 30.9902Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.477498 17.217C0.477498 8.10426 8.08654 0.716946 17.4727 0.716946C23.2204 0.716946 28.3011 3.48743 31.3768 7.72751C28.3668 3.09762 23.0514 0.0217285 16.9953 0.0217285C7.60906 0.0217285 0 7.40905 0 16.5218C0 20.0543 1.144 23.327 3.0911 26.0111C1.43612 23.4653 0.477498 20.45 0.477498 17.217Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3936 2.05981C8.55858 2.05981 2.20703 8.22628 2.20703 15.833C2.20703 19.5169 3.69676 22.863 6.1232 25.3345C4.06148 22.9431 2.81976 19.8625 2.81976 16.5C2.81976 8.89336 9.17132 2.7269 17.0063 2.7269C21.0469 2.7269 24.693 4.36695 27.2768 6.99871C24.6745 3.98011 20.7653 2.05981 16.3936 2.05981Z",
    fill: "#C66709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3771 5.18921C31.8784 8.06253 33.3872 11.7764 33.3872 15.8331C33.3872 24.9458 25.7781 32.333 16.392 32.333C11.5152 32.333 7.11884 30.3383 4.01953 27.144C7.13703 30.7252 11.7969 33.0001 17.0047 33.0001C26.3909 33.0001 33.9999 25.6129 33.9999 16.5001C33.9998 12.122 32.2429 8.14287 29.3771 5.18921Z",
    fill: "#C66709"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0859 28.1028L14.0749 27.664C13.5615 27.4412 13.0523 27.6988 12.7183 28.152L10.259 31.3616C10.0262 31.8528 10.2556 32.4369 10.7689 32.6597L13.3354 33.7736C13.8487 33.9965 13.8362 33.603 13.9602 33.077C14.2425 31.8782 14.601 30.2463 14.7935 29.3007C14.9014 28.7707 15.0809 28.1127 15.0859 28.1028Z",
    fill: "url(#paint1_linear_18586_561742)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3962 28.1085L15.0119 28.3757C15.0537 28.2148 15.0837 28.1067 15.0857 28.1028L14.0747 27.664C13.5613 27.4412 13.0521 27.6988 12.7181 28.152L10.2588 31.3616C10.0633 31.7741 10.1946 32.2512 10.5454 32.5257C10.4644 32.2977 10.4689 32.0414 10.5804 31.8061L13.0397 28.5964C13.3736 28.1432 13.8829 27.8857 14.3962 28.1085Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.7454 27.9556C14.6939 28.1629 14.6374 28.4021 14.593 28.6202C14.4005 29.5658 14.042 31.1977 13.7596 32.3964C13.6357 32.9225 13.6482 33.3159 13.1349 33.0931L10.5684 31.9791C10.4061 31.9086 10.2723 31.8019 10.1724 31.6735C10.1329 32.0784 10.3605 32.4829 10.7679 32.6598L13.3344 33.7737C13.8477 33.9966 13.8351 33.6031 13.9591 33.077C14.2415 31.8782 14.5999 30.2464 14.7925 29.3008C14.9004 28.7708 15.0799 28.1129 15.0849 28.1029L14.7454 27.9556Z",
    fill: "#C66709"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7544 31.3747L21.3088 28.1555C20.9767 27.701 20.4685 27.4415 19.9543 27.6623L18.9414 28.0972C18.9463 28.1071 19.1231 28.7658 19.2287 29.2961C19.4172 30.2424 19.7687 31.8756 20.046 33.0756C20.1678 33.6022 20.1536 33.9954 20.6678 33.7747L23.239 32.6707C23.7532 32.4499 23.9852 31.8667 23.7544 31.3747Z",
    fill: "url(#paint2_linear_18586_561742)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7544 31.3747L21.3088 28.1555C20.9767 27.701 20.4685 27.4415 19.9543 27.6623L18.9414 28.0972C18.9463 28.1071 19.0838 28.6398 19.079 28.6298L20.2444 28.1262C20.7586 27.9054 21.2668 28.1649 21.5989 28.6194L23.8105 31.5305C23.7962 31.478 23.7784 31.4257 23.7544 31.3747Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.756 31.3653L23.502 31.031C23.5935 31.4693 23.3609 31.9286 22.9178 32.1189L20.3466 33.2228C20.242 33.2677 20.1602 33.2861 20.0938 33.2843C20.1761 33.6931 20.2295 33.9541 20.6693 33.7653L23.2405 32.6613C23.7547 32.4406 23.9867 31.8574 23.756 31.3653Z",
    fill: "#C66709"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7542 27.3459H16.3032C15.5665 27.3459 15.1056 27.9156 14.9638 28.6275L13.8477 33.7184C13.8477 34.4233 14.4504 34.9999 15.187 34.9999H18.8704C19.607 34.9999 20.2098 34.4232 20.2098 33.7184L19.0936 28.6275C18.9494 27.9356 18.4909 27.3459 17.7542 27.3459Z",
    fill: "url(#paint3_linear_18586_561742)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7542 27.3459H16.3032C15.5665 27.3459 15.1056 27.9156 14.9638 28.6275L13.8477 33.7184C13.8477 34.0717 13.9992 34.3929 14.2431 34.6252C14.1869 34.484 14.1546 34.3317 14.1546 34.1722L15.2707 29.0814C15.4126 28.3694 15.8735 27.7998 16.6102 27.7998H18.0612C18.4246 27.7998 18.72 27.9437 18.9436 28.1722C18.7226 27.6958 18.3212 27.3459 17.7542 27.3459Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.0879 28.6272C19.0314 28.3556 18.9255 28.1003 18.7742 27.8896C18.7854 27.9314 18.7956 27.9736 18.8044 28.0162L19.9206 33.107C19.9206 33.8119 19.3178 34.3886 18.5812 34.3886H14.8979C14.48 34.3886 14.1054 34.2027 13.8594 33.9134C13.9587 34.5262 14.5143 34.9996 15.1814 34.9996H18.8648C19.6014 34.9996 20.2042 34.4228 20.2042 33.718L19.0879 28.6272Z",
    fill: "#C66709"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6783 30.2247L18.996 30.563L18.1175 31.6577L18.2198 33.094L16.9683 32.545L15.7137 33.094L15.819 31.6577L14.9375 30.563L16.2582 30.2247L16.9683 28.999L17.6783 30.2247Z",
    fill: "url(#paint4_radial_18586_561742)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2578 30.2247L16.9678 31.262V28.999L16.2578 30.2247Z",
    fill: "url(#paint5_radial_18586_561742)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9688 28.999V31.262L17.6788 30.2247L16.9688 28.999Z",
    fill: "url(#paint6_radial_18586_561742)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6788 30.2249L16.9688 31.2622L18.9965 30.5632L17.6788 30.2249Z",
    fill: "url(#paint7_radial_18586_561742)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9965 30.563L16.9688 31.262L18.118 31.6578L18.9965 30.563Z",
    fill: "url(#paint8_radial_18586_561742)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.118 31.6577L16.9688 31.262L18.2203 33.094L18.118 31.6577Z",
    fill: "url(#paint9_radial_18586_561742)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2203 33.094L16.9688 31.262V32.545L18.2203 33.094Z",
    fill: "url(#paint10_radial_18586_561742)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9694 32.545V31.262L15.7148 33.094L16.9694 32.545Z",
    fill: "url(#paint11_radial_18586_561742)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7148 33.094L16.9694 31.262L15.8201 31.6577L15.7148 33.094Z",
    fill: "url(#paint12_radial_18586_561742)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.819 31.6578L16.9683 31.262L14.9375 30.563L15.819 31.6578Z",
    fill: "url(#paint13_radial_18586_561742)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9375 30.5632L16.9683 31.2622L16.2582 30.2249L14.9375 30.5632Z",
    fill: "url(#paint14_radial_18586_561742)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5959 30.343L18.7632 30.643L17.984 31.6133L18.0772 32.8836L16.9671 32.3985L15.8539 32.8836L15.9472 31.6133L15.168 30.643L16.3353 30.343L16.9671 29.2578L17.5959 30.343Z",
    fill: "url(#paint15_radial_18586_561742)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9693 29.6597L16.4669 30.5278L15.5312 30.7672L16.154 31.5428L16.0818 32.5578L16.9693 32.1684L17.8538 32.5578L17.7816 31.5428L18.4044 30.7672L17.4718 30.5278L16.9693 29.6597Z",
    fill: "#EA408E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9678 28.999L16.2578 30.2247C16.339 30.3427 16.9678 29.2959 16.9678 28.999Z",
    fill: "url(#paint16_radial_18586_561742)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2591 30.2249L14.9414 30.5632C15.2092 30.6557 16.3404 30.3429 16.2591 30.2249Z",
    fill: "url(#paint17_radial_18586_561742)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2548 30.5918C15.1495 30.6078 15.0713 30.6078 14.9961 30.5823L15.1676 30.6397L15.2458 30.6206L15.4835 30.5599L15.7392 30.4929L16.3349 30.3397L16.2958 30.2822C16.2958 30.2822 16.3018 30.311 16.3048 30.3237C16.1303 30.378 15.9378 30.429 15.7482 30.4801C15.661 30.5025 15.5767 30.5248 15.4895 30.544C15.4624 30.5503 15.4323 30.5567 15.4053 30.5631C15.3481 30.5759 15.2969 30.5854 15.2518 30.5918H15.2548Z",
    fill: "#F5FBDB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2969 30.2851L16.336 30.3426L16.6549 29.7904L16.7933 29.551L16.9227 29.3308L16.9648 29.2574V29.1138C16.9648 29.184 16.9407 29.2542 16.9076 29.318C16.8595 29.4042 16.8204 29.4808 16.7782 29.5542C16.7331 29.634 16.688 29.7138 16.6429 29.7936C16.5436 29.9692 16.4413 30.1415 16.336 30.3107C16.324 30.3011 16.3119 30.2915 16.2999 30.2819L16.2969 30.2851Z",
    fill: "#E9E4CC"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9693 29.688L16.4669 30.5561L15.5312 30.7923L16.154 31.5679L16.0818 32.5829L16.9693 32.1967L17.8538 32.5829L17.7816 31.5679L18.4044 30.7923L17.4718 30.5561L16.9693 29.688Z",
    fill: "#F53D51"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.154 31.5681L16.9693 31.2872L15.5312 30.7925L16.154 31.5681Z",
    fill: "url(#paint18_radial_18586_561742)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5312 30.7923L16.9693 31.2871L16.4669 30.5562L15.5312 30.7923Z",
    fill: "url(#paint19_radial_18586_561742)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4648 30.5561L16.9673 31.287V29.688L16.4648 30.5561Z",
    fill: "url(#paint20_radial_18586_561742)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4712 30.5562L16.9688 31.2871L18.4038 30.7923L17.4712 30.5562Z",
    fill: "url(#paint21_radial_18586_561742)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4038 30.7925L16.9688 31.2872L17.7811 31.5681L18.4038 30.7925Z",
    fill: "url(#paint22_radial_18586_561742)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7811 31.568L16.9688 31.2871L17.8533 32.583L17.7811 31.568Z",
    fill: "url(#paint23_radial_18586_561742)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8533 32.583L16.9688 31.2871V32.1968L17.8533 32.583Z",
    fill: "url(#paint24_radial_18586_561742)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9656 32.1968V31.2871L16.0781 32.583L16.9656 32.1968Z",
    fill: "url(#paint25_radial_18586_561742)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0781 32.583L16.9656 31.2871L16.1503 31.568L16.0781 32.583Z",
    fill: "url(#paint26_radial_18586_561742)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9688 29.688V31.287L17.4712 30.5561L16.9688 29.688Z",
    fill: "url(#paint27_radial_18586_561742)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2773 30.7062L15.5301 30.7923L16.4657 30.5562L16.3755 30.4253L15.2773 30.7062Z",
    fill: "url(#paint28_radial_18586_561742)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9677 29.4041L16.375 30.4254L16.4653 30.5563L16.9677 29.6881V29.4041Z",
    fill: "url(#paint29_radial_18586_561742)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9688 29.6881L17.4712 30.5563L17.5584 30.4254L16.9688 29.4041V29.6881Z",
    fill: "url(#paint30_radial_18586_561742)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6541 30.7062L17.556 30.4253L17.4688 30.5562L18.4014 30.7923L18.6541 30.7062Z",
    fill: "url(#paint31_radial_18586_561742)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.404 30.7925L17.7812 31.5681L17.9257 31.6191L18.6567 30.7063L18.404 30.7925Z",
    fill: "url(#paint32_radial_18586_561742)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0129 32.8126L17.9257 31.6189L17.7812 31.5679L17.8535 32.5828L18.0129 32.8126Z",
    fill: "url(#paint33_radial_18586_561742)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8533 32.583L16.9688 32.1968V32.3564L18.0127 32.8128L17.8533 32.583Z",
    fill: "url(#paint34_radial_18586_561742)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9219 32.8128L16.9688 32.3564V32.1968L16.0813 32.583L15.9219 32.8128Z",
    fill: "url(#paint35_radial_18586_561742)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0813 32.5828L16.1535 31.5679L16.0091 31.6189L15.9219 32.8126L16.0813 32.5828Z",
    fill: "url(#paint36_radial_18586_561742)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2773 30.7063L16.0084 31.6191L16.1528 31.5681L15.5301 30.7925L15.2773 30.7063Z",
    fill: "url(#paint37_radial_18586_561742)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6571 31.0285C16.6872 30.9902 16.6301 30.8338 16.4255 30.5657L15.6914 30.754C16.0223 30.8944 16.594 31.1146 16.6571 31.0285Z",
    fill: "url(#paint38_radial_18586_561742)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4961 30.5019C16.5533 30.6392 16.821 31.0573 16.8842 31.0381C16.9113 31.0286 16.9233 30.9232 16.9323 30.7828C16.9474 30.4764 16.9534 30.0806 16.9203 29.7678L16.4961 30.4987V30.5019Z",
    fill: "url(#paint39_radial_18586_561742)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1367 31.7723C16.245 31.5871 16.579 31.3829 16.6813 31.4914C16.7264 31.5393 16.6903 31.651 16.6572 31.7371L16.9671 31.2871L16.1548 31.568L16.1397 31.7723H16.1367Z",
    fill: "url(#paint40_radial_18586_561742)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4584 31.466L16.8615 31.2872L15.3633 30.7351L16.8796 31.2138L16.672 30.8564L16.9187 31.1787L16.9698 29.5222L17.021 31.1628L17.2135 30.9298L17.0481 31.2106L18.1823 30.8691L17.0541 31.2904L17.361 31.4245L17.018 31.3128L17.4301 31.9639L16.9759 31.3607L16.9698 31.7501L16.9458 31.3543L16.1756 32.4459L16.9006 31.3192L16.4584 31.466Z",
    fill: "url(#paint41_radial_18586_561742)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M16.9666 32.5034C17.5996 32.5034 18.1128 31.9589 18.1128 31.2873C18.1128 30.6157 17.5996 30.0713 16.9666 30.0713C16.3335 30.0713 15.8203 30.6157 15.8203 31.2873C15.8203 31.9589 16.3335 32.5034 16.9666 32.5034Z",
    fill: "url(#paint42_radial_18586_561742)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M16.4661 30.8531C16.6156 30.8531 16.7369 30.7245 16.7369 30.5658C16.7369 30.4072 16.6156 30.2786 16.4661 30.2786C16.3165 30.2786 16.1953 30.4072 16.1953 30.5658C16.1953 30.7245 16.3165 30.8531 16.4661 30.8531Z",
    fill: "url(#paint43_radial_18586_561742)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18586_561742",
    x1: 14.8682,
    y1: 0.763771,
    x2: 19.3723,
    y2: 36.1155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F7E436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D58D21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18586_561742",
    x1: 12.5283,
    y1: 26.9197,
    x2: 12.8838,
    y2: 38.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F7E436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D58D21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18586_561742",
    x1: 21.504,
    y1: 26.9241,
    x2: 21.1018,
    y2: 38.8261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F7E436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D58D21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18586_561742",
    x1: 17.0287,
    y1: 26.7408,
    x2: 17.0287,
    y2: 38.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#F7E436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D58D21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9683 31.0449) scale(1.97962 2.10016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1BB98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6128 30.1289) scale(0.794255 0.842619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E894"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3238 30.1289) scale(0.794255 0.842619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D68A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D972"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8051 30.4132) scale(0.797263 0.845811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C58100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1A824"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2474 31.7599) scale(1.57347 1.66928)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A65B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C47D02"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2624 31.7535) scale(2.66857 2.83107)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C58100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1A824"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9116 32.6216) scale(1.75398 1.86078)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A65B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C47D02"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8731 32.7142) scale(2.09695 2.22464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A65B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C47D02"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.754 31.7822) scale(1.82318 1.93419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D68A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D972"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7709 31.6897) scale(1.7269 1.83205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D972"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7396 31.3994) scale(1.71487 1.81929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D233"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3172 29.9472) scale(2.97846 3.15982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5256 29.0565) scale(1.13121 1.20009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E894"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.788 30.1419) scale(1.95254 2.07143)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D233"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5824 30.4382) scale(1.63665 1.7363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9668 29.7231) scale(3.34249 3.54599)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0677 30.0774) scale(1.81716 1.9278)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5644 29.388) scale(1.65169 1.75225)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EA5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A300"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8581 31.3095) scale(1.82618 1.93738)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2124 32.9404) scale(1.92245 2.03952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.2252 31.1722) scale(2.48204 2.63318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.027 32.9117) scale(1.96157 2.08101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8002 33.1798) scale(1.87131 1.98526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.364 29.5699) scale(2.53921 2.69382)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9783 31.769) scale(1.32677 1.40755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9226 29.4998) scale(1.84123 1.95335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5E36B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C811"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5223 29.0913) scale(2.0428 2.1672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59C00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7444 30.2306) scale(2.10297 2.23101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4883 30.3297) scale(1.41402 1.50011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.2825 32.3594) scale(2.28349 2.42253)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.775 33.2692) scale(1.37791 1.46181)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4454 33.3522) scale(1.80813 1.91823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1427 32.7488) scale(1.42605 1.51288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59C00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7027 30.4159) scale(1.7961 1.90546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1427 30.438) scale(1.27863 1.35647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#360500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6465 29.9817) scale(1.35384 1.43628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#360500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9972 31.3988) scale(1.42605 1.5129)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FCBA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7713 30.984) scale(1.39295 1.47778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#360500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9666 31.2873) scale(1.14625 1.21605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FCBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F5AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#360500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_18586_561742",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4661 30.5658) scale(0.270769 0.287259)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FCBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F58F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#BB6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#823C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#581E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3F0B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#360500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18586_561742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.9999,
    height: 34.9999,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.4c7a1ceaff1b7772feb1b1bc4ca1e53c.svg";
export { ForwardRef as ReactComponent };